import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Connector, Package, PackageHost } from '../../Container';
import { inSessionProperties } from '../EditorSession';
import { StateProperty } from '../ExtendableStore';
import { toolEquip } from '../tooling/ToolCommands';
import { debugTool, defaultTool, handTool, pointerToolboxItem } from './Definitions';
import { QuickCreateInfo } from './QuickCreateInfo';
import { SlapMechanics } from './SlapMechanics';
import { SlapRelay } from './SlapRelay';
import { inToolboxItems, ToolboxController } from './ToolboxController';
import { PrevToolInfo, ToolInfo } from './ToolInfo';
import { inTools, ToolManager } from './ToolManager';
import { ToolShortcutMechanics } from './ToolShortcutMechanics';

const inBasicTools = () => inTools(debugTool, defaultTool, handTool);
const useDefaultTool: Connector = r => void (r.call(CommandDispatcher)(toolEquip, ['default']));

export class ToolingPackage implements Package {

    public install = (host: PackageHost) => host
        .register(SlapMechanics, 'singleton', 'startable')
        .register(SlapRelay, 'singleton')
        .register(ToolManager, 'singleton', 'startable')
        .register(ToolboxController, 'singleton', 'startable')
        .register(ToolShortcutMechanics, 'singleton', 'startable')
        .plug(
            inSessionProperties(
                StateProperty.variable(QuickCreateInfo, QuickCreateInfo.empty),
                StateProperty.variable(ToolInfo, ToolInfo.empty),
                StateProperty.variable(PrevToolInfo, ToolInfo.empty),
            ),
            inBasicTools(),
            useDefaultTool,
        )
        .plug(
            inToolboxItems(pointerToolboxItem)
        );
}
